
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "updateNoteResolvedAt",
      resolverType: "mutation",
      routePath: "/updateNoteResolvedAt",
      httpMethod: "POST",
    });
  